<template>
  <article
    class="page-container full-width company-post single-post"
    v-if="company"
  >
    <header class="page-header">
      <div
        class="thumbnail-container"
        :style="{
          backgroundImage: `url(${$options.filters.imageproxy(
            company.image_url,
            1160
          )})`,
        }"
        v-if="company"
      >
        <img
          :src="$options.filters.imageproxy(company.image_url, 1160)"
          :alt="`${company.title} - Thumbnail`"
          class="show-for-sr"
        />
      </div>
      <div class="title-container">
        <h1 class="post-title">{{ company.title }}</h1>
      </div>
      <div class="meta-infos">
        <span
          class="category"
          v-if="company.category"
          >{{ company.category }}</span>
        <span class="distance" v-if="company.distance >= 0">
          <img src="@/assets/svgs/2024/icons/distance.svg" alt="distance">
          {{ (company.distance / 1000).toFixed(0) + $t("isAway") }}
        </span>
        <!--<span class="likes" v-if="company.likes >= 0">
          <font-awesome-icon :icon="['far', 'thumbs-up']" />
          {{ company.likes }} likes
        </span>-->
        <div class="bookmarks-btn-container">
          <button type="button" :class="{ 'button btn-add-to-bookmarks btn-icon' :true, 'in-bookmarks': inBookmarks}" @click="toggleBookmark">
            <img src="@/assets/svgs/2024/icons/heart.svg" alt="bookmark" v-if="!this.inBookmarks">
            <img src="@/assets/svgs/2024/icons/heart-filled.svg" alt="bookmark" v-if="this.inBookmarks">
          </button>
        </div>
      </div>

      <div class="card-discounts" v-if="company.details">
        <h2
          class="discount-headline"
          v-if="this.$store.state.season === 'sommer'"
        >
          {{ $t("withApp") }}
        </h2>
        <h2
          class="discount-headline"
          v-if="this.$store.state.season === 'winter'"
        >
          {{ $t("withAppWinter") }}
        </h2>
        <div v-if="company.details.price_with_card" class="use-info">
          {{ company.details.price_with_card }}
        </div>
        <div v-else class="use-info">{{ company.details.use_info }}</div>
        <div class="savings" v-show="company.details.saving">
          {{ `${$t("savings")} ${company.details.saving}` }}
        </div>

        <section class="criterias" v-if="company.criteria">
          <criteria-icon
              :name="criteria"
              icon-size="1.5rem"
              v-for="criteria in company.criteria"
              :key="`criteria-${criteria}`"
          />
        </section>

      </div>

      <back-button fixed :from="from" />
    </header>

    <section
      class="page-content-container"
      v-if="company"
      v-html="company.details.content"
    />

    <section class="tipps" v-if="company.details.info">
      <h4>{{ $t("hint") }}</h4>

      <div class="tipp-content" v-html="company.details.info" />
    </section>

    <hr class="section-divider" v-if="company.details.info" />

    <section class="opening-hours" v-if="company.details.openings">
      <h4 class="text-primary">{{ $t("openingHours") }}</h4>
      <p
        class="hours"
        v-for="(openings, key) in company.details.openings"
        :key="`openings-${key}`"
      >
        {{ openings }}
      </p>
      <div class="retention-periode">
        <span class="periode-icon">
          <img src="@/assets/svgs/2024/icons/clock.svg">
        </span>

        <div class="periode-text">
          {{ $t("spendTime") }}<br /><strong>{{
            company.details.retention_period
          }}</strong>
        </div>
      </div>
    </section>

    <hr class="section-divider" v-if="company.details.openings" />

    <section class="contact-infos">
      <div class="info address-info" v-if="company.details.address">
        <div class="info-icon-wrapper">
          <div class="info-icon button">
            <img src="@/assets/svgs/2024/icons/location.svg">
          </div>
        </div>
        <div class="info-wrapper">
          <span class="address">{{ company.details.address }}</span>
        </div>
      </div>
      <div class="info telefon-info" v-if="company.details.phone">
        <div class="info-icon-wrapper">
          <div class="info-icon button">
            <img src="@/assets/svgs/2024/icons/phone.svg">
          </div>
        </div>
        <div class="info-wrapper">
          <a
            :href="`tel://${$options.filters.normalizePhoneNumber(number)}`"
            class="phone"
            v-for="(number, key) in company.details.phone"
            :key="`phone-${key}`"
            >{{ number }}</a
          >
        </div>
      </div>
      <div class="info email-info" v-if="company.details.email">
        <div class="info-icon-wrapper">
          <div class="info-icon button">
            <img src="@/assets/svgs/2024/icons/mail.svg">
          </div>
        </div>
        <div class="info-wrapper">
          <a
            class="email"
            target="_blank"
            rel="noopener nofollow"
            :href="`mailto:${company.details.email}`"
            >{{ company.details.email }}</a
          >
        </div>
      </div>
      <div class="info web-info" v-if="company.details.homepage">
        <div class="info-icon-wrapper">
          <div class="info-icon button">
            <img src="@/assets/svgs/2024/icons/extern-link.svg">
          </div>
        </div>
        <div class="info-wrapper">
          <a
            class="weblink"
            target="_blank"
            rel="noopener nofollow"
            :href="`${formatUrl(company.details.homepage)}`"
            >{{ company.details.homepage }}</a
          >
        </div>
      </div>
      <div class="info arrival-info" v-if="company.details.arrival_info">
        <div class="info-icon-wrapper">
          <div class="info-icon button">
            <img src="@/assets/svgs/2024/icons/navigation.svg">
          </div>
        </div>
        <div class="info-wrapper">
          <span class="arrival" v-html="company.details.arrival_info" />
        </div>
      </div>
    </section>

    <hr
      class="section-divider"
      v-if="this.company.webcam_typ && this.company.webcam_link"
    />

    <section
      class="webcam"
      v-if="this.company.webcam_typ && this.company.webcam_link"
    >
      <!-- <p>Typ: {{this.company.webcam_typ}}</p>
			<p>Link: {{this.company.webcam_link}}</p> -->
      <div class="video-container" v-if="this.company.webcam_typ == 'video'">
        <video autoplay loop muted playsinline>
          <source :src="this.company.webcam_link" type="video/mp4" />
          Your browser does not support the videos.
        </video>
      </div>
      <div class="image-container" v-if="this.company.webcam_typ == 'picture'">
        <img :src="this.company.webcam_link" :alt="this.company.webcam_link" />
      </div>
      <div class="iframe-container" v-if="this.company.webcam_typ == 'iframe'">
        <!-- <iframe src="" frameborder="0"></iframe> -->
      </div>
    </section>

    <hr class="section-divider" />

    <section class="actions">
      <div class="action-container">
        <a
          :href="
            this.mapLink(company.coords.lat, company.coords.lng, company.title)
          "
          type="button"
          class="btn-icon btn-route"
          target="_blank"
        >
          <img src="@/assets/svgs/2024/icons/navigation.svg">
        </a>
        <span class="button-text">{{ $t("buttonActions.route") }}</span>
      </div>
      <div class="action-container">
        <button
          type="button"
          class="btn-icon btn-map"
          @click="navigateToMap"
        >
          <img src="@/assets/svgs/2024/icons/location.svg">
        </button>
        <span class="button-text">{{ $t("buttonActions.map") }}</span>
      </div>
      <div class="action-container">
          <button type="button" :class="{ 'button btn-add-to-bookmarks btn-icon' :true, 'in-bookmarks': inBookmarks}" @click="toggleBookmark">
            <img src="@/assets/svgs/2024/icons/heart.svg" alt="bookmark" v-if="!this.inBookmarks">
            <img src="@/assets/svgs/2024/icons/heart-filled.svg" alt="bookmark" v-if="this.inBookmarks">
          </button>
        <span class="button-text">{{ $t("buttonActions.bookmarks") }}</span>
      </div>
      <!--<div class="action-container">
        <button
          type="button"
          :class="{ 'button btn-like': true, liked: this.isLiked }"
          @click="likeCompany"
        >
          <font-awesome-icon :icon="['far', 'thumbs-up']" size="2x" />
        </button>
        <span class="button-text">{{ $t("buttonActions.likes") }}</span>
      </div>-->
      <div class="action-container">
        <button
          type="button"
          class="btn-icon btn-share"
          @click="openShareReveal"
        >
          <img src="@/assets/svgs/2024/icons/share.svg">
        </button>
        <span class="button-text">{{ $t("buttonActions.share") }}</span>
      </div>
    </section>

    <section class="buy-card">
      <a
        class="btn-buy-card button btn-with-icon btn-arrow"
        data-scope="week"
        :href="weekCardLink"
        target="_blank"
        rel="nofollow noopener"
      >
        <span class="button-text">{{ $t("buyCards.weekCard") }}</span>
      </a>
      <a
        class="btn-buy-card button btn-with-icon btn-arrow"
        data-scope="season"
        :href="seasonCardLink"
        target="_blank"
        rel="nofollow noopener"
      >
        <span class="button-text">{{ $t("buyCards.seasonCard") }}</span>
      </a>
    </section>

    <section class="nearby-companies" v-if="nearbyCompanies.length >= 1">
      <h4>{{ $t("nearby") }}</h4>
      <company-slider :items="nearbyCompanies" />
    </section>

    <share-reveal
      ref="shareReveal"
      id="share-reveal"
      :key="`share-reveal-${company.id}`"
      :entity="company"
      :share-link="shareLink"
      :scrape-link="scrapeLink"
      v-if="company && company.details && company.details.content"
      v-on:close-share-reveal="closeShareReveal"
    />
  </article>
</template>

<script>
import foundation from "@/mixins/foundation";
import BackButton from "@/components/BackButton.vue";
import CriteriaIcon from "@/components/CriteriaIcon.vue";
import CompanySlider from "@/components/CompanySlider.vue";
import ShareReveal from "@/components/ShareReveal.vue";
import Mixins from "@/components/Mixins.vue"

export default {
  name: "SingleCompanyPage",
  components: {
    BackButton,
    CriteriaIcon,
    CompanySlider,
    ShareReveal,
  },
  mixins: [foundation,Mixins],
  data() {
    return {
      isLoading: true,
      from: null,
      nearbyRange: 25000, // in meters
    };
  },
  metaInfo() {
    return {
      title:
        this.company.title +
        " | " +
        this.$t("services") +
        " | " +
        "Kärnten Card App",
      meta: [
        {
          property: "og:title",
          content:
            this.company.title +
            " | " +
            this.$t("services") +
            " | " +
            "Kärnten Card App",
        },
        {
          property: "og:site_name",
          content: "Kärnten Card App",
        },
        {
          property: "og:url",
          content: window.location.href,
        },
        {
          property: "og:image",
          content: this.$options.filters.imageproxy(
            this.company.image_url,
            1160
          ),
        },
        {
          property: "og:description",
          content: this.$options.filters.sanitizedDescription(
            this.company.details.content
          ),
        },
      ],
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.from = from.name;
    });
  },
  computed: {
    company() {
      return this.$store.getters.getCompanyByID(this.$route.params.uuid);
    },
    categoryObject() {
      let catObj = this.$store.getters.getCurrentCategories.filter(
        (cat) => cat.name === this.company.category
      );
      if (catObj.length == 1) {
        return catObj[0];
      }
      return { color_code: "#2f2f2f" };
    },
    bookmarkIcon() {
      if (this.inBookmarks) {
        return ["fas", "heart"];
      } else {
        return ["fal", "heart"];
      }
    },
    inBookmarks() {
      return (
        this.$store.getters.getCurrentBookmarks.filter(
          (company) => company.id === this.company.id
        ).length === 1
      );
    },
    isLiked() {
      return this.$store.getters.hasCompanyAlreadyLiked(this.company.id);
    },
    nearbyCompanies() {
      if (this.$store.state.currentPosition === undefined) {
        return [];
      }

      return this.$store.getters.getNearbyCompanies(this.nearbyRange);
    },
    shareLink() {
      return window.location.href;
    },
    scrapeLink() {
      return `https://app.kaerntencard.at/admin/sharer/destinations/${this.company.id}`;
    },
    weekCardLink() {
      return this.$store.state.shopLink[this.$store.state.season].weekCardLink;
    },
    seasonCardLink() {
      return this.$store.state.shopLink[this.$store.state.season]
        .seasonCardLink;
    },
  },
  methods: {
    likeCompany() {
      this.$store.dispatch("updateCompanyLikes", this.company);
    },
    toggleBookmark() {
      if (this.inBookmarks) {
        this.removeFromBookmarks();
      } else {
        this.addToBookmarks();
      }
    },
    removeFromBookmarks() {
      this.$store.dispatch("removeBookmark", this.company.id);
    },
    addToBookmarks() {
      let bookmarkObject = {
        id: this.company.id,
        type: "company",
      };
      this.$store.dispatch("createBookmark", bookmarkObject);
    },
    navigateToMap() {
      let that = this;
      let designation = this.company.designation.includes("Ausflugsziel")
        ? "companies"
        : "bonusClub";
      this.$router.push({
        name: "map",
        params: {
          id: that.company.id,
          entity: designation,
        },
      });
    },
    openShareReveal() {
      this.$refs.shareReveal.$el.classList.add("is-reveal-open");
    },
    closeShareReveal() {
      this.$refs.shareReveal.$el.classList.remove("is-reveal-open");
    },
  },
  mounted() {
    $(this.$refs.shareReveal).foundation();
    // console.log("this company object: ", this.company);
    // console.log("state: ", this.$store.state.companies);
  },
  watch: {
    "$store.state.language": function () {
      let newID = this.company.translations[this.$store.state.language];
      if (newID) {
        this.$store
          .dispatch("fetchCardInfos", {
            lang: this.$store.state.language,
            season: this.$store.state.season,
          })
          .then(() => {
            this.$store.dispatch("fetchNews", {
              lang: this.$store.state.language,
              season: this.$store.state.season,
            });
          });
        this.$store
          .dispatch("fetchCompany", { id: newID })
          .then(() => {
            this.$router.push({
              name: "single-destination",
              params: { uuid: newID },
            });
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.company-post {
  .page-header {
    position: relative;
    .thumbnail-container {
      height: rem-calc(270px);
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;

      @include breakpoint(medium) {
        height: rem-calc(540px);
      }
    }

    .title-container {
      margin: 1rem rem-calc(15);

      .post-title {
        font-size: 1.8rem;
        font-weight: bold;
        text-align: left;
      }
    }

    .meta-infos {
      @include flex();
      @include xy-gutters();
      justify-content: space-between;
      align-items: center;
      margin-bottom: rem-calc(20);

      .category {
        margin: 0;
        padding: 0;
        color: get-color(primary);
      }

      .distance {
        display: flex;
        font-size: 0.875rem;
        margin: 0 1rem;

        img {
          margin-right: 0.5rem;
          height: 18px;
          width: 18px;
        }
      }
    }

    .card-discounts {
      @include xy-gutters();
      margin: 0 0 rem-calc(25) 0;
      padding: map-get($grid-padding-gutters, "small") / 2;
      border-radius: rem-calc(3);
      background-color: $light-gray;

      h2.discount-headline {
        margin-bottom: 0;
        font-size: rem-calc(21);
        font-weight: bold;
      }

      .savings {
        font-size: rem-calc(16);
        margin-top: 0.5rem;
      }

      @include breakpoint(medium) {
        padding: map-get($grid-padding-gutters, "medium") / 2;
      }
    }
  }

  hr.section-divider {
    max-width: 100vw;
    border-bottom: 1px solid rgba($dark-gray, 0.1);
  }

  section.page-content-container {
    white-space: pre-wrap;
  }

  section.tipps {
    @include xy-gutters();
    padding: map-get($grid-padding-gutters, "small") / 2;
    background-color: #a8dcf4;
    border-radius: rem-calc(3);

    h4 {
      margin-bottom: rem-calc(20);
      font-size: rem-calc(12);
      font-weight: 700;
    }

    @include breakpoint(medium) {
      padding: map-get($grid-padding-gutters, "medium") / 2;
    }
  }

  section.opening-hours {
    @include xy-gutters();

    h4 {
      margin-bottom: rem-calc(20);
    }

    .hours {
    }

    .retention-periode {
      @include flex();
      @include flex-align(left, top);

      .periode-icon {
      }
      .periode-text {
        margin-top: 0.25rem;
        padding-left: 1rem;
      }
    }
  }

  section.contact-infos {
    @include xy-gutters();
    .info {
      @include flex();
      @include flex-align(left, top);
      margin-bottom: 1rem;

      .info-icon-wrapper {
        margin-right: 1rem;
      }
      .info-wrapper {
        margin-top: 0.5rem;

        a {
          color: $dark-gray;
        }

        &:hover {
          a {
            color: get-color(primary);
          }
        }
      }
    }
  }

  section.criterias {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
  }

  .info-icon,
  .btn-icon,
  .btn-add-to-bookmarks {
    width: rem-calc(44);
    height: rem-calc(44);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    background-color: $light-gray;
    border: 1px solid $light-gray;
    font-size: 1.25rem;
    border-radius: 50%;
    margin: 0;

    &.in-bookmarks {
      background-color: $white;
    }

    img, svg {
      height: rem-calc(26);
      width: auto;
      max-width: rem-calc(26);
    }
  }

  .btn-icon {
    cursor: pointer;
    &:hover {
      border-color: $dark-gray;
      background-color: white;
    }
  }

  section.actions {
    @include xy-gutters();
    @include flex();
    @include flex-align(center, middle);

    .action-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      &:not(:last-child) {
        margin-right: 1.25rem;
      }

      .button-text {
        font-size: 0.875rem;
        margin-top: 0.5rem;
        display: inline-block;
      }
    }
  }

  section.buy-card {
    margin: 0 auto;
    width: 100%;
    max-width: 340px;
    display: flex;
    flex-direction: column;
    padding: 1rem;
  }

  section.nearby-companies {
    @include xy-gutters($gutter-type: padding);
    position: relative;
    padding-top: 1rem;
    padding-bottom: 1rem;
    margin-top: 1rem;
    border-top: 1px solid rgba($dark-gray, 0.1);
    box-shadow: 0px 0px 2px rgba($black, 0.15);
    z-index: 1;

    &:before {
      content: "";
      height: 1rem;
      position: absolute;
      top: -1.1rem;
      left: 0;
      right: 0;
      background-color: $light-gray;
    }

    h4 {
      margin-bottom: 1rem;
      font-size: rem-calc(20);
    }
  }

  section.webcam {
    .video-container {
      video {
        width: 100%;
        object-fit: contain;
      }
    }
    .image-container {
      img {
        width: 100%;
      }
    }
    .iframe-container {
      iframe {
        width: 100%;
        height: 400px;
      }
    }
  }
}
</style>
